import { element } from "prop-types";
import { lazy, Suspense } from "react";
import SuspenseLoader from "src/components/SuspenseLoader";
import Callback from "src/content/pages/Callback";
import Status404 from "src/content/pages/Status/Status404";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Dashboard = Loader(lazy(() => import("src/content/luModule/dashboard")));
const Users = Loader(lazy(() => import("src/content/luModule/Users")));
const Analytics = Loader(lazy(() => import("src/content/luModule/Analytics")));
const ComimgSoon = Loader(
  lazy(() => import("src/components/_shared/ComingSoon"))
);
const ComingSooner = Loader(
  lazy(() => import("src/content/pages/Status/ComingSoon"))
);
const AddUserGroup = Loader(
  lazy(() => import("src/content/luModule/UserGroups/Components/Create"))
);
const TcsUserGroupVendor = Loader(
  lazy(() => import("src/content/luModule/UserGroups/Components/CreateMember"))
);
const ProposalList = Loader(
  lazy(() => import("src/content/luModule/ProposalsList"))
);
const Proposals = Loader(
  lazy(() => import("src/content/luModule/Proposals/index"))
);

const Profile = Loader(lazy(() => import("src/content/luModule/Profile")));

const MasterTemplate = Loader(
  lazy(() => import("src/content/luModule/MasterTemplate"))
);

const TemplateBank = Loader(
  lazy(() => import("src/content/luModule/ProposalTemplatePreview/index"))
);

const MasterTemplateBank = Loader(
  lazy(() => import("src/content/luModule/MasterTemplate/index"))
);

const TemplateBankList = Loader(
  lazy(() => import("src/content/luModule/TemplatesBank/index"))
);

const TemplateSelect = Loader(
  lazy(() => import("src/content/luModule/TemplatesBank/TemplateSelect"))
);

const EditTemplate = Loader(
  lazy(() => import("src/content/luModule/TemplatesBank/EditTemplate"))
);

const ProposalSelect = Loader(
  lazy(()=>import("src/content/luModule/PastProposal/ProposalSelect"))
)

const PastProposal = Loader(
  lazy(()=>import("src/content/luModule/PastProposal/index"))
)

const PastProposalPreview = Loader(
  lazy(()=>import("src/content/luModule/PastProposalPreview/index"))
)

const FAQ = Loader(lazy(()=> import("src/content/luModule/FAQ")))

const HelpCenter = Loader(lazy(() => import("src/content/luModule/Resources")));

export const vendorDashboardsRoutes = [
  {
    path: "/",
    element: <Dashboard />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/dashboard",
    element: <Dashboard />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/users",
    element: <Users />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/user-group/create",
    element: <AddUserGroup />,
    roles: ["vendor_admin"],
  },
  {
    path: "vendor/user-group/edit/:id",
    element: <AddUserGroup />,
    roles: ["vendor_admin"],
  },
  {
    path:"vendor/analytics",
    element:<Analytics/>,
    role:["vendor_user","vendor_admin"]
  },
  {
    path: "vendor/user-group/add-members",
    element: <TcsUserGroupVendor />,
    roles: ["vendor_admin"],
  },
  {
    path: "vendor/user-group/edit-members/:id",
    element: <TcsUserGroupVendor />,
    roles: ["vendor_admin"],
  },
  {
    path: "vendor/profile",
    element: <Profile />,
  },
  {
    path: "vendor/faq-center",
    element: <FAQ />,
  },
  {
    path: "vendor/proposal-in-progress",
    element: <ComimgSoon />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/proposal-list",
    element: <ProposalList />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/coming-soon",
    element: <ComingSooner />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/templates-bank-list",
    element: <TemplateBankList />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "vendor/master-proposal-template",
    element: <MasterTemplate />,
    roles: ["vendor_user", "vendor_admin"],
  },

  {
    path: "vendor/help-center",
    element: <HelpCenter dashboard={false}/>,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "callback",
    element: <Callback />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "*",
    element: <Status404 />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "/comingsoon",
    element: <ComimgSoon />,
    roles: ["vendor_user", "vendor_admin"],
  },
];

export const ProposalRoutes = [
  {
    path: "",
    element: <Proposals />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "preliminaryinformation",
    element: <Proposals />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "scopeofwork",
    element: <Proposals />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "preview",
    element: <Proposals />,
    roles: ["vendor_user", "vendor_admin"],
  },
];

export const TemplateRoutes = [
  {
    path: "",
    element: <TemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "description",
    element: <TemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "scope",
    element: <TemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "template-bank/select-list",
    element: <TemplateSelect />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "edit-template/preliminaryinformation",
    element: <EditTemplate />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "edit-template/scopeofwork",
    element: <EditTemplate />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "edit-template/preview",
    element: <EditTemplate />,
    roles: ["vendor_user", "vendor_admin"],
  },
];

export const PastProposalRoutes = [
  {
    path: "",
    element: <PastProposal />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "past-proposal/select-list",
    element:<ProposalSelect/> ,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "past-proposal/description",
    element: <PastProposalPreview />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "past-proposal/scope",
    element: <PastProposalPreview />,
    roles: ["vendor_user", "vendor_admin"],
  },
 
];

export const MasterTemplateRoutes = [
  {
    path: "",
    element: <MasterTemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "preliminaryinformation",
    element: <MasterTemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "scopeofwork",
    element: <MasterTemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
  {
    path: "preview",
    element: <MasterTemplateBank />,
    roles: ["vendor_user", "vendor_admin"],
  },
];
